import { ReactComponent as ActivityIcon } from "assets/productIcons/activity.svg"
import { ReactComponent as CourseIcon } from "assets/productIcons/course.svg"
import { ReactComponent as DefaultIcon } from "assets/productIcons/default.svg"
import { ReactComponent as ExamIcon } from "assets/productIcons/exam.svg"
import { ReactComponent as FastIcon } from "assets/productIcons/fast.svg"
import { ReactComponent as FileIcon } from "assets/productIcons/file.svg"
import { ReactComponent as LinkIcon } from "assets/productIcons/link.svg"
import { ReactComponent as PDFIcon } from "assets/productIcons/pdf.svg"
import { ReactComponent as TalkIcon } from "assets/productIcons/talk.svg"
import { ReactComponent as VideoIcon } from "assets/productIcons/video.svg"
import type { ProductTypeIdentifier } from "../../../graphql"

import s from "./CheckpointCard.module.scss"

export const CheckpointCardIcon = ({
  productType,
}: {
  productType: ProductTypeIdentifier
}) => {
  const getIcon = () => {
    switch (productType) {
      case "activity":
        return ActivityIcon
      case "assessment":
        return ExamIcon
      case "dialogue":
      case "skills_real_talk":
        return TalkIcon
      case "fast":
      case "fast_survey":
      case "quiz_race":
        return FastIcon
      case "file":
        return FileIcon
      case "link":
        return LinkIcon
      case "pdf":
        return PDFIcon
      case "scorm":
      case "xapi":
        return CourseIcon
      case "video":
        return VideoIcon
      default:
        return DefaultIcon
    }
  }

  const IconSVG = getIcon()

  return <IconSVG className={s.icon} />
}
